'use client';

import * as a from "react";
import p$1 from "../lib/IconBase.es.js";
import e$1 from "../defs/LockSimple.es.js";
const e = a.forwardRef((m, c) => /* @__PURE__ */ a.createElement(p$1, { ref: c, ...m, weights: e$1 }));
e.displayName = "LockSimpleIcon";
const p = e;
export {
  p as LockSimple,
  e as LockSimpleIcon
};
